import * as React from 'react'
import { FunctionComponent } from 'react'

import { Input } from '../../types'
import { LookupFinder } from './LookupFinder'

interface LookupFormInputMeta {
  endpoint: string
  minimumLookupChars: number
}

export const LookupFormInput: FunctionComponent<Input<string, LookupFormInputMeta>> = ({
  value,
  onChange,
  meta: { endpoint, minimumLookupChars },
  tKey,
  tName,
  t,
}) => (
  <LookupFinder
    tName={tName}
    initialValue={value}
    tKey={tKey}
    t={t}
    endpoint={endpoint}
    minimumLookupChars={minimumLookupChars}
    onSelect={onChange}
  />
)
